import * as React from "react";
import { HeadFC, PageProps } from "gatsby";
import {
  PageContainer,
  PAGE_CONTAINER_VARIANT,
  RecordDetailsContainer,
} from "../../components";
import StayInLoop from "../../components/StayInLoop";

const DetailsPage: React.FC<PageProps> = (props) => {
  const companyName = props.params.company;

  return (
    <PageContainer variant={PAGE_CONTAINER_VARIANT.DETAILS}>
      <RecordDetailsContainer companyName={companyName} />
      <div className="mt-5">
        <StayInLoop />
      </div>
    </PageContainer>
  );
};

export default DetailsPage;

export { Head } from "../../components/Head";
